import React from "react";
import type { PresentedText } from "@shared/site-audit-report-view";

export function PresentedCopy({
  value,
  className,
  inline = false,
}: {
  value: PresentedText;
  className?: string;
  inline?: boolean;
}) {
  const Tag = inline ? "span" : "p";
  return (
    <Tag className={className}>
      {value.segments.map((segment, index) =>
        segment.flagged ? (
          <mark
            key={index}
            className="rounded bg-amber-200/80 px-0.5 text-amber-950 dark:bg-amber-400/20 dark:text-amber-100"
            title="Not in the source data"
          >
            {segment.text}
            <span className="sr-only"> (not in the source data)</span>
          </mark>
        ) : (
          <span key={index}>{segment.text}</span>
        ),
      )}
    </Tag>
  );
}
